import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-dropdown", () => {
    it("should open and have clickable elements", async () => {
        const page = await newE2EPage();
        await page.setContent(`
        <ux-dropdown
            search-placeholder="Search me"
            filterable
            placeholder="Filterable Dropdown"
        >
            <ux-checkbox-list-item
                label="abc"
                value="1"
                name="checkbox"
                input-id="1"
            ></ux-checkbox-list-item>
            <ux-checkbox-list-item
                label="def"
                value="2"
                name="checkbox"
                input-id="2"
            ></ux-checkbox-list-item>
            <ux-checkbox-list-item
                label="abx"
                value="3"
                name="checkbox"
                input-id="3"
            ></ux-checkbox-list-item>
        </ux-dropdown>`);
        const uxDropdown = await page.find("ux-dropdown");
        const firstListItem = await uxDropdown.find("ux-checkbox-list-item ux-checkbox");
        const eventHandler = await page.spyOnEvent("uxCheckboxListItemChange");
        expect(uxDropdown).toHaveClass("hydrated");
        await page.waitForChanges();
        expect(uxDropdown).not.toHaveClass("ux-dropdown--down");
        await uxDropdown.click();
        await page.waitForChanges();
        expect(uxDropdown).toHaveClass("ux-dropdown--down");
        await page.waitForChanges();
        await firstListItem.click();
        await page.waitForChanges();
        expect(eventHandler).toHaveReceivedEventDetail({
            checked: true,
            inputId: "1",
            name: "checkbox",
            value: "1"
        });
        expect(uxDropdown).toHaveClass("ux-dropdown--down");
    });

    it("should handle single option correctly", async () => {
        const page = await newE2EPage();
        await page.setContent(`
        <ux-dropdown placeholder="Select your desired machine">
            <ux-radio-list-item label="Machine Choice 1" value="1" name="machine-value"></ux-radio-list-item>
            <ux-radio-list-item label="Machine Choice 2" value="2" name="machine-value"></ux-radio-list-item>
            <ux-radio-list-item label="Machine Choice 3" value="3" name="machine-value"></ux-radio-list-item>
        </ux-dropdown>`);
        const uxDropdown = await page.find("ux-dropdown");
        const firstListItem = await uxDropdown.find("ux-radio-list-item ux-radio-button");
        const eventHandler = await page.spyOnEvent("uxRadioListItemChange");
        await page.waitForChanges();
        expect(uxDropdown).not.toHaveClass("ux-dropdown--down");
        await uxDropdown.click();
        await page.waitForChanges();
        expect(uxDropdown).toHaveClass("ux-dropdown--down");
        await page.waitForChanges();
        await firstListItem.click();
        const counter = await uxDropdown.find(".ux-dropdown__counter");
        await page.waitForChanges();
        expect(counter).toBeNull();
        expect(eventHandler).toHaveReceivedEvent();
        expect(uxDropdown).not.toHaveClass("ux-dropdown--down");
    });

    it("should show an indicator of how many items are selected", async () => {
        const page = await newE2EPage();
        await page.setContent(`
        <ux-dropdown placeholder="Select your desired machine">
            <ux-checkbox-list-item label="Machine Choice 1" value="1" name="machine-value"></ux-checkbox-list-item>
            <ux-checkbox-list-item checked label="Machine Choice 2" value="2" name="machine-value"></ux-checkbox-list-item>
            <ux-checkbox-list-item label="Machine Choice 3" value="3" name="machine-value"></ux-checkbox-list-item>
        </ux-dropdown>`);
        const uxDropdown = await page.find("ux-dropdown");
        await page.waitForChanges();
        const counter = await uxDropdown.find(".ux-dropdown__counter");
        expect(counter).toEqualText("1");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-dropdown></ux-dropdown>`);
        const el = await page.find("ux-dropdown");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`
        <ux-dropdown
            search-placeholder="Search me"
            filterable
            placeholder="Filterable Dropdown"
        >
            <ux-checkbox-list-item
                label="abc"
                value="1"
                name="checkbox"
                input-id="1"
            ></ux-checkbox-list-item>
        </ux-dropdown>
        `);
    });
});
